import { render, staticRenderFns } from "./CreateCampaignReviewCardEditInput.vue?vue&type=template&id=24863360&scoped=true"
import script from "./CreateCampaignReviewCardEditInput.vue?vue&type=script&lang=js"
export * from "./CreateCampaignReviewCardEditInput.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignReviewCardEditInput.vue?vue&type=style&index=0&id=24863360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24863360",
  null
  
)

export default component.exports